// Funcion para reducir el numero de llamados al API
let timerIdAsync;

const debounce = (callback, params, delay = 500) => {
  return new Promise((resolve, reject) => {
    clearTimeout(timerIdAsync);

    timerIdAsync = setTimeout(() => {
      callback(params)
        .then((result) => resolve(result))
        .catch((error) => reject(error));
    }, delay);
  });
};

export default debounce;
